module.exports = __webpack_public_path__ + "assets/img/urlLogo-light.fe122c95.png";